import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Button, Menu, MenuItem, Stack } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import * as DocumentHelper from '../../api/document/documentHelper';
import { IDocument } from '../../shared/iDocument';
import Span from '../../shared/component/Span';
import { EStatusCode } from '../../api/enum';

interface IHelpProps {}

const Help = (props: IHelpProps) => {
    const { t } = useTranslation();

    const [document, setDocument] = React.useState<IDocument[] | null>();

    React.useEffect(() => {
        const fetchDocument = async () => {
            let res = await DocumentHelper.getAllDocumentAsync();
            if (res.status == EStatusCode.Ok) {
                setDocument(res.data);
            }
        };
        fetchDocument();
    }, []);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Stack>
            <Button
                variant='greenLight'
                startIcon={<HelpOutlineIcon />}
                id='help-button'
                endIcon={<KeyboardArrowDownIcon />}
                aria-controls={open ? 'help-menu' : undefined}
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                <Span text={t('help')} />
            </Button>
            <Menu
                id='help-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'help-button',
                }}>
                {document?.map(x => (
                    <MenuItem key={x!.name} onClick={() => (location.href = x.documentUrl)}>
                        {x!.name}
                    </MenuItem>
                ))}
            </Menu>
        </Stack>
    );
};

export default Help;
